import { render, staticRenderFns } from "./GlobalChatToast.vue?vue&type=template&id=bb612aee&scoped=true"
import script from "./GlobalChatToast.vue?vue&type=script&lang=js"
export * from "./GlobalChatToast.vue?vue&type=script&lang=js"
import style0 from "./GlobalChatToast.vue?vue&type=style&index=0&id=bb612aee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb612aee",
  null
  
)

export default component.exports